export let options_messagePreview_Off = "gc8agc";
export let options_messagePreview_oneLine = "ZVjTEd";
export let options_messagePreview_twoLines = "KIRDab";
export let options_messagePreview_threeLines = "SRydfd";
export let options_messagePreview_inline = "aXEnDb";
export let options_messageList_previewLabel = "bjoR6c";
export default {options_messagePreview_Off,options_messagePreview_oneLine,options_messagePreview_twoLines,options_messagePreview_threeLines,options_messagePreview_inline,options_messageList_previewLabel};